import React from "react";
import { ContentText, TitleTour } from "../components/ReactourComponents/styles";

export const stepsTourTokenCard = [
    {
        selector: "#card-form",
        content: () => (
            <div>
                <TitleTour>Tokenizar Cartão</TitleTour>
                <ContentText>Tokenizar um cartão é fácil, comece por preencher os campos de textos</ContentText>
            </div>
        )
    }, //inputWithIcon
    {
        selector: "#inputWithIcon",
        content: () => (
            <div>
                <TitleTour>Tokenizar Cartão</TitleTour>
                <ContentText>Ao começar a digitar o nome de um cliente cadastrado, irá aparecer uma lista com os clientes que combinam com o texto digitado, é importante que você clique em um.</ContentText>
            </div>
        )
    },
    {
        selector: "#credit-card",
        content: () => (
            <div>
                <TitleTour>Tokenizar Cartão</TitleTour>
                <ContentText>Ao preencher os campos, você irá perceber que as informações do cartão serão atualizadas</ContentText>
            </div>
        )
    },
    {
        selector: "#button-submit",
        content: () => (
            <div>
                <TitleTour>Tokenizar Cartão</TitleTour>
                <ContentText>Ao finalizar o preenchimento, basta clicar no botão e aguardar a confirmação</ContentText>
            </div>
        )
    }
]